// import React, { useEffect, useState } from "react"
// import Draggable from "react-draggable"
// import { ResizableBox } from "react-resizable"
// import List from "../../assets/images/flags/bucket-list.png"
// import hourGlass from "../../assets/images/icons8-hourglass.gif"
// import StopIcon from "../../assets/images/Dashboard/punch-stop.png"
// import StartIcon from "../../assets/images/Dashboard/punch-start.png"
// import PunchIcon from "../../assets/images/Dashboard/punch.png"
// import PunchLogs from "./PunchLogs"
// import secureLocalStorage from "react-secure-storage"
// import Swal from "sweetalert2"
// import { fetchNodeData } from "utils/common-fetchData"
// import moment from "moment"
// import Loader from "pages/Separate/Loader"
// import TimerDisplay from "./TimerDisplay" // Import new component

// const isSameDay = (date1, date2) => {
//   return (
//     date1.getFullYear() === date2.getFullYear() &&
//     date1.getMonth() === date2.getMonth() &&
//     date1.getDate() === date2.getDate()
//   )
// }

// const TimerClockHr = () => {
//   const [ticketList, setTicketList] = useState(false)
//   const [openOption, setOpenOption] = useState(false)
//   const [isOpen, setIsOpen] = useState(false)
//   const [isLoading, setLoading] = useState(false)
//   const [isHovered, setIsHovered] = useState(false)
//   const [logs, setLogs] = useState([])
//   const [previousDate, setPreviousDate] = useState("")
//   const userId = localStorage.getItem("auth_id")
//   const token = secureLocalStorage.getItem("auth_token")

//   const syncTimerState = async () => {
//     const today = moment().format("YYYY-MM-DD")

//     const res = await fetchNodeData(
//       setLoading,
//       `wfhpunch/${userId}/${today}`,
//       token
//     )

//     if (!res?.status) return

//     const logs = res.punchLogs || []
//     const count = logs.length

//     // ODD → user is punched IN
//     if (count % 2 !== 0) {
//       const lastPunch = logs[count - 1] // LAST log is punch-in without punch-out

//       // Convert punch_time ("HH:mm:ss") to a timestamp today
//       const punchTime = lastPunch.punch_time
//       const punchDate = new Date(`${today} ${punchTime}`)

//       // Set timer as running
//       setOpenOption(true)
//       localStorage.setItem("isTimer", "true")
//       localStorage.setItem("startTime", punchDate.getTime())
//       localStorage.setItem("startDate", punchDate.toISOString())
//     } else {
//       // EVEN → user is punched OUT
//       setOpenOption(false)
//       localStorage.setItem("isTimer", "false")
//       localStorage.removeItem("startTime")
//     }
//   }

//   // On component mount: check timer state
// //   useEffect(() => {
// //     const savedStart = localStorage.getItem("startTime")
// //     const savedRunning = localStorage.getItem("isTimer") === "true"

// //     if (savedRunning && savedStart) {
// //       setOpenOption(true)
// //     }
// //   }, [])

// useEffect(() => {
//   syncTimerState();
// }, []);

// useEffect(() => {
//   if (isOpen) syncTimerState();
// }, [isOpen]);



//   useEffect(() => {
//     localStorage.setItem("isTimer", openOption)
//   }, [openOption])

//   const handleToggle = async () => {
//     const endpoint = `wfhpunch/${userId}`

//     const stopTimer = async () => {
//       const res = await fetchNodeData(setLoading, endpoint, token)
//       if (res?.status) {
//         const startTime = Number(localStorage.getItem("startTime"))
//         const now = Date.now()
//         const elapsed = Math.floor((now - startTime) / 1000)

//         const previous = parseInt(
//           localStorage.getItem("elapsedTime") || "0",
//           10
//         )
//         localStorage.setItem("elapsedTime", previous + elapsed)

//         Swal.fire({
//           icon: "success",
//           title: "Timer Stopped Successfully",
//         })

//         setOpenOption(false)
//         localStorage.removeItem("startTime")
//       }
//     }

//     const startTimer = async () => {
//       const res = await fetchNodeData(setLoading, endpoint, token)
//       if (res?.status) {
//         Swal.fire({
//           icon: "success",
//           title: "Time Logged Successfully",
//         })
//         setIsHovered(false)
//         setPreviousDate(localStorage.getItem("startDate"))
//         localStorage.setItem("startTime", Date.now())
//         localStorage.setItem("startDate", new Date())
//         setOpenOption(true)
//       }
//     }

//     if (openOption) {
//       const confirm = await Swal.fire({
//         icon: "warning",
//         title: "Are you sure?",
//         text: "Are you finishing your work or taking a break? Confirm to stop the timer.",
//         showCancelButton: true,
//         confirmButtonText: "Yes, Stop it!",
//         cancelButtonText: "No, cancel!",
//       })

//       if (confirm?.isConfirmed) {
//         await stopTimer()
//       }
//     } else {
//       const confirm = await Swal.fire({
//         icon: "warning",
//         title: "Are you sure?",
//         text: "Are you starting your work session or returning from a break? Confirm to start the timer.",
//         showCancelButton: true,
//         confirmButtonText: "Yes, Start it!",
//         cancelButtonText: "No, cancel!",
//       })
//       if (confirm?.isConfirmed) {
//         await startTimer()
//       }
//     }
//   }

//   const getPunchLogs = async () => {
//     const today = moment().format("YYYY-MM-DD")
//     const res = await fetchNodeData(
//       setLoading,
//       `wfhpunch/${userId}/${today}`,
//       token
//     )
//     if (res?.status) {
//       const logs = res?.punchLogs
//       const result = []
//       for (let i = 0; i < logs?.length; i += 2) {
//         result.push({
//           punch_date: logs[i].punch_date,
//           punch_in: logs[i]?.punch_time || "",
//           punch_out: logs[i + 1]?.punch_time || "",
//         })
//       }
//       setTicketList(!ticketList)
//       setLogs(result)
//     }
//   }

//   const startTime = Number(localStorage.getItem("startTime")) || Date.now()
//   const savedElapsed = parseInt(localStorage.getItem("elapsedTime"), 10) || 0
//   const today = new Date()

//   return (
//     <div>
//       {isLoading && <Loader />}
//       <Draggable handle=".floating-button">
//         <div className={`floating-container timer-box ${isOpen ? "show" : ""}`}>
//           <div
//             className={`floating-button timer ${openOption ? "timer-on" : ""} `}
//             onClick={() => setIsOpen(!isOpen)}
//           >
//             <div className="pulse"></div>
//             <div className="position-absolute w-100 h-100"></div>

//             <img
//               src={openOption ? hourGlass : PunchIcon}
//               alt="Bug"
//               width={32}
//               height={32}
//             />
//           </div>
//           {isOpen ? (
//             <div className="element-container">
//               <a
//                 className="float-element"
//                 onClick={() => getPunchLogs()}
//                 title="All Reported Bugs"
//               >
//                 <img
//                   className="material-icons"
//                   src={List}
//                   alt="Bug"
//                   width={28}
//                   height={28}
//                 />
//               </a>
//               <a
//                 className="float-element timer-check"
//                 title="Timer Start / Stop"
//                 onClick={() => handleToggle()}
//               >
//                 {openOption ? (
//                   <span
//                     className="text-black fw-bold"
//                     onMouseEnter={() => setIsHovered(true)}
//                     onMouseLeave={() => setIsHovered(false)}
//                   >
//                     {isHovered ? (
//                       <img
//                         className="material-icons"
//                         src={StopIcon}
//                         alt="Stop"
//                         width={22}
//                         height={22}
//                       />
//                     ) : (
//                       <TimerDisplay
//                         isRunning={openOption}
//                         startTime={startTime}
//                         initialSeconds={
//                           isSameDay(new Date(previousDate), today)
//                             ? savedElapsed
//                             : 0
//                         }
//                       />
//                     )}
//                   </span>
//                 ) : (
//                   <img
//                     className="material-icons ms-1"
//                     src={StartIcon}
//                     alt="Start"
//                     width={28}
//                     height={28}
//                   />
//                 )}
//               </a>
//             </div>
//           ) : null}
//         </div>
//       </Draggable>

//       <div className={`note-sticky-form ${ticketList ? "d-block" : "d-none"}`}>
//         <Draggable handle=".modal-header" cancel=".modal-body">
//           <ResizableBox
//             width={900}
//             style={{
//               position: "fixed",
//               top: "18%",
//               right: "15%",
//               zIndex: "999",
//               backgroundColor: "#fff",
//               maxHeight: "fit-content",
//               transform: "translate(-50%, -50%)",
//             }}
//           >
//             <div className="modal-header ">
//               <h5 className="modal-title mt-0">Today's Punch Logs</h5>
//               <button
//                 type="button"
//                 onClick={() => {
//                   setTicketList(false)
//                 }}
//                 className="btn-modal-close"
//               >
//                 <span aria-hidden="true" className="btn-modal-span">
//                   &times;
//                 </span>
//               </button>
//             </div>
//             <PunchLogs data={logs} />
//           </ResizableBox>
//         </Draggable>
//       </div>
//     </div>
//   )
// }

// export default TimerClockHr






import React, { useEffect, useState } from "react"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import List from "../../assets/images/flags/bucket-list.png"
import hourGlass from "../../assets/images/icons8-hourglass.gif"
import StopIcon from "../../assets/images/Dashboard/punch-stop.png"
import StartIcon from "../../assets/images/Dashboard/punch-start.png"
import PunchIcon from "../../assets/images/Dashboard/punch.png"
import PunchLogs from "./PunchLogs"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import TimerDisplay from "./TimerDisplay" // Import new component

const isSameDay = (date1, date2) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}

const TimerClockHr = () => {
  const [ticketList, setTicketList] = useState(false)
  const [openOption, setOpenOption] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const [logs, setLogs] = useState([])
  const [previousDate, setPreviousDate] = useState("")
  const userId = localStorage.getItem("auth_id")
  const token = secureLocalStorage.getItem("auth_token")

  const syncTimerState = async () => {
    const today = moment().format("YYYY-MM-DD")

    const res = await fetchNodeData(
      setLoading,
      `wfhpunch/${userId}/${today}`,
      token
    )

    if (!res?.status) return

    const logs = res.punchLogs || []
    const count = logs.length

    // ODD → user is punched IN
    if (count % 2 !== 0) {
      const lastPunch = logs[count - 1] // LAST log is punch-in without punch-out

      // Convert punch_time ("HH:mm:ss") to a timestamp today
      const punchTime = lastPunch.punch_time
      const punchDate = new Date(`${today} ${punchTime}`)

      // Set timer as running
      setOpenOption(true)
      localStorage.setItem("isTimer", "true")
      localStorage.setItem("startTime", punchDate.getTime())
      localStorage.setItem("startDate", punchDate.toISOString())
    } else {
      // EVEN → user is punched OUT
      setOpenOption(false)
      localStorage.setItem("isTimer", "false")
      localStorage.removeItem("startTime")
    }
  }

  // On component mount: check timer state
  //   useEffect(() => {
  //     const savedStart = localStorage.getItem("startTime")
  //     const savedRunning = localStorage.getItem("isTimer") === "true"

  //     if (savedRunning && savedStart) {
  //       setOpenOption(true)
  //     }
  //   }, [])

  useEffect(() => {
    syncTimerState();
  }, []);

  useEffect(() => {
    if (isOpen) syncTimerState();
  }, [isOpen]);


  useEffect(() => {
    localStorage.setItem("isTimer", openOption)
  }, [openOption])

  const getPunchPayload = () => {
    const now = new Date();

    const date = now.toISOString().split("T")[0]; // YYYY-MM-DD
    const time = now.toTimeString().split(" ")[0]; // HH:mm:ss

    return { date, time };
  };

  const handleToggle = async () => {
    const { date, time } = getPunchPayload();
    const endpoint = `wfhpunch`

    const stopTimer = async () => {
      let type = 1;
      const res = await FetchNodePostData(setLoading, endpoint, token, { userId, date, time, type })
      const stopMessage = res?.data?.stopMessage || res?.stopMessage;
      const message = res?.data?.message || res?.message;
      if (res?.status) {

        if (stopMessage === "stop") {
          Swal.fire({
            icon: "info",
            title: message,
          });

          setOpenOption(false);
          localStorage.removeItem("startTime");
          return;
        }



        const startTime = Number(localStorage.getItem("startTime"))
        const now = Date.now()
        const elapsed = Math.floor((now - startTime) / 1000)

        const previous = parseInt(
          localStorage.getItem("elapsedTime") || "0",
          10
        )
        localStorage.setItem("elapsedTime", previous + elapsed)

        Swal.fire({
          icon: "success",
          title: res?.data?.message,
        })

        setOpenOption(false)
        localStorage.removeItem("startTime")
      }
    }

    const startTimer = async () => {
      const res = await FetchNodePostData(setLoading, endpoint, token, { userId, date, time })
      if (res?.status) {
        Swal.fire({
          icon: "success",
          title: "Time Logged Successfully",
        })
        setIsHovered(false)
        setPreviousDate(localStorage.getItem("startDate"))
        localStorage.setItem("startTime", Date.now())
        localStorage.setItem("startDate", new Date())
        setOpenOption(true)
      }
    }

    if (openOption) {
      const confirm = await Swal.fire({
        icon: "warning",
        title: "Are you sure?",
        text: "Are you finishing your work or taking a break? Confirm to stop the timer.",
        showCancelButton: true,
        confirmButtonText: "Yes, Stop it!",
        cancelButtonText: "No, cancel!",
      })

      if (confirm?.isConfirmed) {
        await stopTimer()
      }
    } else {
      const confirm = await Swal.fire({
        icon: "warning",
        title: "Are you sure?",
        text: "Are you starting your work session or returning from a break? Confirm to start the timer.",
        showCancelButton: true,
        confirmButtonText: "Yes, Start it!",
        cancelButtonText: "No, cancel!",
      })
      if (confirm?.isConfirmed) {
        await startTimer()
      }
    }
  }

  const getPunchLogs = async () => {
    const today = moment().format("YYYY-MM-DD")
    const res = await fetchNodeData(
      setLoading,
      `wfhpunch/${userId}/${today}`,
      token
    )
    if (res?.status) {
      const logs = res?.punchLogs

      if (logs.length % 2 == 1) {
        setOpenOption(true);
        localStorage.setItem("isTimer", "true")
      } else {
        setOpenOption(false)
        localStorage.setItem("isTimer", "false")
      }

      const result = []
      for (let i = 0; i < logs?.length; i += 2) {
        result.push({
          punch_date: logs[i].punch_date,
          punch_in: logs[i]?.punch_time || "",
          punch_out: logs[i + 1]?.punch_time || "",
        })
      }
      setTicketList(!ticketList)
      setLogs(result)
    }
  }

  const startTime = Number(localStorage.getItem("startTime")) || Date.now()
  const savedElapsed = parseInt(localStorage.getItem("elapsedTime"), 10) || 0
  const today = new Date()

  return (
    <div>
      {isLoading && <Loader />}
      <Draggable handle=".floating-button">
        <div className={`floating-container timer-box ${isOpen ? "show" : ""}`}>
          <div
            className={`floating-button timer ${openOption ? "timer-on" : ""} `}
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="pulse"></div>
            <div className="position-absolute w-100 h-100"></div>

            <img
              src={openOption ? hourGlass : PunchIcon}
              alt="Bug"
              width={32}
              height={32}
            />
          </div>
          {isOpen ? (
            <div className="element-container">
              <a
                className="float-element"
                onClick={() => getPunchLogs()}
                title="All Reported Bugs"
              >
                <img
                  className="material-icons"
                  src={List}
                  alt="Bug"
                  width={28}
                  height={28}
                />
              </a>
              <a
                className="float-element timer-check"
                title="Timer Start / Stop"
                onClick={() => handleToggle()}
              >
                {openOption ? (
                  <span
                    className="text-black fw-bold"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    {isHovered ? (
                      <img
                        className="material-icons"
                        src={StopIcon}
                        alt="Stop"
                        width={22}
                        height={22}
                      />
                    ) : (
                      <TimerDisplay
                        isRunning={openOption}
                        startTime={startTime}
                        initialSeconds={
                          isSameDay(new Date(previousDate), today)
                            ? savedElapsed
                            : 0
                        }
                      />
                    )}
                  </span>
                ) : (
                  <img
                    className="material-icons ms-1"
                    src={StartIcon}
                    alt="Start"
                    width={28}
                    height={28}
                  />
                )}
              </a>
            </div>
          ) : null}
        </div>
      </Draggable>

      <div className={`note-sticky-form ${ticketList ? "d-block" : "d-none"}`}>
        <Draggable handle=".modal-header" cancel=".modal-body">
          <ResizableBox
            width={900}
            style={{
              position: "fixed",
              top: "18%",
              right: "15%",
              zIndex: "999",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header ">
              <h5 className="modal-title mt-0">Today's Punch Logs</h5>
              <button
                type="button"
                onClick={() => {
                  setTicketList(false)
                }}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>
            <PunchLogs
              data={logs}
            />
          </ResizableBox>
        </Draggable>
      </div>
    </div>
  )
}

export default TimerClockHr
